var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationCap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1897,
    height: 1897,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-276 -276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898 1497.75C898 1433.55 1050.89 1381.5 1239.5 1381.5 1428.11 1381.5 1581 1433.55 1581 1497.75 1581 1561.95 1428.11 1614 1239.5 1614 1050.89 1614 898 1561.95 898 1497.75L898 1265.25C898 1201.05 1050.89 1149 1239.5 1149 1428.11 1149 1581 1201.05 1581 1265.25L1581 1497.75",
    stroke: "#262626",
    strokeWidth: 48.125,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 1474C1685 1450.8 1703.8 1432 1727 1432 1750.2 1432 1769 1450.8 1769 1474 1769 1497.2 1750.2 1516 1727 1516 1703.8 1516 1685 1497.2 1685 1474Z",
    stroke: "#262626",
    strokeWidth: 34.375,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1713.5,
    y: 1243.5,
    width: 27.9999,
    height: 189,
    stroke: "#262626",
    strokeWidth: 9.16667,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 591.969 337.886",
    stroke: "#262626",
    strokeWidth: 36.6667,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 647.5 1187.39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.5 849.5 1831.47 1187.39",
    stroke: "#262626",
    strokeWidth: 36.6667,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.5 1187.5 895.948 1328.92",
    stroke: "#262626",
    strokeWidth: 36.6667,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 244.91 137.836",
    stroke: "#262626",
    strokeWidth: 36.6667,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 1586.5 1325.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.50007C-9.54858e-16 3.35789 3.35789 -9.54858e-16 7.50007-1.90972e-15 11.6422-3.81943e-15 15.0001 3.35789 15.0001 7.50007 15.0001 11.6422 11.6422 15.0001 7.50007 15.0001 3.35789 15.0001-4.77429e-15 11.6422 0 7.50007Z",
    stroke: "#262626",
    strokeWidth: 9.16667,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#262626",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 1829.5 1195.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.99987C-9.54858e-16 3.13395 3.35789 -8.91177e-16 7.50007-1.78235e-15 11.6422-3.56471e-15 15.0001 3.13395 15.0001 6.99987 15.0001 10.8658 11.6422 13.9997 7.50007 13.9997 3.35789 13.9997-4.77429e-15 10.8658 0 6.99987Z",
    stroke: "#262626",
    strokeWidth: 9.16667,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#262626",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 1232.5 849.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.50007C-9.54858e-16 3.35789 3.35789 -9.54858e-16 7.50007-1.90972e-15 11.6422-3.81943e-15 15.0001 3.35789 15.0001 7.50007 15.0001 11.6422 11.6422 15.0001 7.50007 15.0001 3.35789 15.0001-4.77429e-15 11.6422 0 7.50007Z",
    stroke: "#262626",
    strokeWidth: 9.16667,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#262626",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 632.5 1195.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.5 567.969C419.5 485.972 485.972 419.5 567.969 419.5L1882.03 419.5C1964.03 419.5 2030.5 485.972 2030.5 567.969L2030.5 1882.03C2030.5 1964.03 1964.03 2030.5 1882.03 2030.5L567.969 2030.5C485.972 2030.5 419.5 1964.03 419.5 1882.03Z",
    stroke: "#262626",
    strokeWidth: 55,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.32c88d1a81d9d55d56def3cd7850c4cb.svg";
export { ForwardRef as ReactComponent };